import React, { useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { useQuery } from '@apollo/client';
import { Button, IconSvg, useOutsideClick } from '@utex/ui-kit';
import { BalanceTooltip } from '../BalanceTooltip';
import query from './query';
import { BalanceButton, getButtonColor, Container } from './styles';
import { getGrossSum, getInvestSum } from './helpers';
import { MoneyView } from '../../../MoneyView';
var useScreenStore = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = useQuery(query, { errorPolicy: 'ignore' }), loading = _h.loading, data = _h.data;
    var balances = {};
    if (!loading && data) {
        if ((_a = data.currentUser) === null || _a === void 0 ? void 0 : _a.balances) {
            var userUsdBalance = (_b = data.currentUser.balances) === null || _b === void 0 ? void 0 : _b.find(function (balance) { return balance.amount.currency.code === 'USD'; });
            balances.freeUsdBalance = {
                value: Number(((_c = userUsdBalance === null || userUsdBalance === void 0 ? void 0 : userUsdBalance.amount) === null || _c === void 0 ? void 0 : _c.value) || 0),
                currency: 'USD',
            };
        }
        if (((_d = data.bnh) === null || _d === void 0 ? void 0 : _d.positionsSummary) && ((_e = data.limited) === null || _e === void 0 ? void 0 : _e.positionsSummary) && ((_f = data.unlimited) === null || _f === void 0 ? void 0 : _f.positionsSummary) && ((_g = data.stocks) === null || _g === void 0 ? void 0 : _g.positionsSummary)) {
            var grossSum = getGrossSum(data);
            var investSum = getInvestSum(data);
            balances.grossSum = { value: grossSum, currency: 'USD' };
            balances.investSum = { value: investSum, currency: 'USD' };
        }
        if (balances.freeUsdBalance && balances.investSum && balances.grossSum) {
            var userBalanceSumm = balances.freeUsdBalance.value + balances.grossSum.value + balances.investSum.value;
            balances.userBalanceSumm = { value: userBalanceSumm, currency: 'USD' };
        }
    }
    return balances;
};
export var Balance = observer(function (_a) {
    var view = _a.view, openDeposit = _a.openDeposit, openWithdraw = _a.openWithdraw, onAccountsClick = _a.onAccountsClick;
    var _b = useState(false), isTooltipOpen = _b[0], setTooltipOpen = _b[1];
    var containerRef = useRef(null);
    useOutsideClick(containerRef, isTooltipOpen, function () { return setTooltipOpen(false); });
    var balances = useScreenStore();
    return (React.createElement(Container, { ref: containerRef },
        React.createElement(BalanceButton, { "data-testid": "balance-btn", type: "button", view: view, isTooltipOpen: isTooltipOpen, onClick: function () { return setTooltipOpen(true); } },
            React.createElement(MoneyView, { rule: "0-2" }, balances.userBalanceSumm)),
        React.createElement(Button, { shape: "square", size: "S", view: getButtonColor(view), isBlured: view !== 'default', onClick: function (e) {
                e.preventDefault();
                openDeposit();
            }, "data-testid": "deposit-btn", "data-gtm": "deposit-plus-icon-btn" },
            React.createElement(IconSvg, { src: "plus" })),
        React.createElement(BalanceTooltip, { free: balances.freeUsdBalance, investedSum: balances.investSum, grossSum: balances.grossSum, isTooltipVisible: isTooltipOpen, openDeposit: openDeposit, openWithdraw: openWithdraw, onAccountsClick: onAccountsClick, view: view })));
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/UserBlock/components/Balance/index.js
// module id = 1364
// module chunks = 118